import React from "react";
import {Accordion, AccordionTab} from "primereact/accordion";
import Aux from "../../../../../../hoc/Auxiliary"
import TopicsConfigurations from "./TopicsConfigurations/TopicsConfigurations";


const QueriesDetailsConfigurations = (props) => {

    return (
        <Aux>
            <Accordion multiple activeIndex={[0]}>
                {
                    props.categories.map((cg) => {
                        return (
                            <AccordionTab key={cg.id} header={cg.name}>
                                <TopicsConfigurations topicsDetails={props.topicsDetails}
                                                      setTopicsDetails={props.setTopicsDetails} category={cg}
                                                      dataCollection={props.dataCollection}/>
                            </AccordionTab>)
                    })}
            </Accordion>
        </Aux>
    )
}

export default QueriesDetailsConfigurations;




